import { render, staticRenderFns } from "./SortableList.vue?vue&type=template&id=f9c766e2&scoped=true"
import script from "./SortableList.vue?vue&type=script&lang=ts"
export * from "./SortableList.vue?vue&type=script&lang=ts"
import style0 from "./SortableList.vue?vue&type=style&index=0&id=f9c766e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c766e2",
  null
  
)

export default component.exports